"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _CurrencyFormatting = require("../internal/utils/CurrencyFormatting");

var _CurrencyLabelFormatters = require("I18n/internal/utils/CurrencyLabelFormatters");

var CurrencySelect = function CurrencySelect(props) {
  var currencyStyle = props.currencyStyle,
      validCurrencies = props.validCurrencies,
      currenciesFilter = props.currenciesFilter,
      passThroughProps = (0, _objectWithoutProperties2.default)(props, ["currencyStyle", "validCurrencies", "currenciesFilter"]);
  return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, passThroughProps, {
    className: props.className,
    options: (0, _CurrencyFormatting.getCurrencyOptions)({
      currencyStyle: currencyStyle,
      currenciesFilter: currenciesFilter,
      validCurrencies: validCurrencies
    })
  }));
};

CurrencySelect.propTypes = {
  className: _react.PropTypes.string,
  currencyStyle: _react.PropTypes.oneOf(Object.keys(_CurrencyLabelFormatters.currencyStyles)).isRequired,
  validCurrencies: _react.PropTypes.array,
  currenciesFilter: _react.PropTypes.func
};
CurrencySelect.defaultProps = {
  currencyStyle: _CurrencyLabelFormatters.currencyStyles.short
};
var _default = CurrencySelect;
exports.default = _default;
module.exports = exports.default;